<div *ngIf="visit" id="visit-form">
  <div
    class="visit-form-header d-flex align-items-center justify-content-between"
  >
    <img
      class="logo"
      [src]="
        isStore103 && entityData?.storeImage
          ? logostorePath + entityData.storeImage
          : entityData?.image
            ? logoPath + entityData.image
            : ''
      "
      alt="Logo"
    />
    <h1 class="title">Ficha de Visita</h1>
    <div class="visit-details">
      <table class="visit-info-table">
        <thead>
          <tr>
            <th>Data</th>
            <th>Hora</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ visit.date | date: "dd/MM/yyyy" }}</td>
            <td>{{ visit.time }}</td>
          </tr>
        </tbody>
      </table>
      <table class="visit-info-table">
        <thead>
          <tr>
            <th>Colaborador</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ visit.agentName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <table class="visit-info-table mt-2">
    <thead>
      <tr>
        <th style="width: 60%">Nome do Interessado no Imóvel</th>
        <th style="width: 40%">Contacto</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{{ visit.clientName }}</td>
        <td>{{ visit.clientContact }}</td>
      </tr>
    </tbody>
  </table>
  <div class="d-flex mt-2">
    <table class="visit-info-table flex-fill me-2">
      <tbody>
        <tr>
          <td>
            <div class="d-flex align-items-center gap-2">
              <div class="property-image">
                <img
                  *ngIf="visit.property.image"
                  width="80"
                  [src]="propertyPath + visit.property.image"
                  alt="Property Image"
                />
              </div>
              <div>
                <div>{{ visit.property.title }}</div>
                <div>
                  {{
                    visit.property.businessType == "SALE"
                      ? "Venda"
                      : "Arrendamento"
                  }}
                  {{ visit.property.price }} {{ visit.property.symbol ?? "€" }}
                </div>
                <div>Área Bruta: {{ visit.property.grossArea }}</div>
                <div>
                  Ano de Construção:
                  {{ visit.property.yearBuilt | date: "dd-MM-yyyy" }}, Classe
                  Energética: {{ visit.property.energeticCertification }}
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="min-width: 220px">
      <table class="visit-info-table mb-2">
        <thead>
          <tr>
            <th>Referência</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ visit.property.reference }}</td>
          </tr>
        </tbody>
      </table>
      <table class="visit-info-table">
        <thead>
          <tr>
            <th>Angariador</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ visit.property.listingAgent ?? visit.agentName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <table class="visit-info-table mt-2">
    <thead>
      <tr>
        <th>Morada</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="height: 25px">{{ visit.property.address }}</td>
      </tr>
    </tbody>
  </table>

  <table class="visit-info-table mt-2">
    <thead>
      <tr>
        <th>
          Avaliação do imóvel pelo interessado (1 é a pior avaliação; 5 é a
          melhor avaliação)
        </th>
      </tr>
    </thead>
  </table>

  <div class="d-flex gap-2 mt-2">
    <div class="w-50">
      <table class="visit-info-table flex-fill">
        <tbody>
          <tr
            *ngFor="let criterion of ['Localização', 'Estado de conservação']"
          >
            <td class="bg-table-head fw-bold">{{ criterion }}</td>
            <td *ngFor="let score of [1, 2, 3, 4, 5]" class="text-center">
              {{ score }}
            </td>
          </tr>
        </tbody>
      </table>
      <table class="visit-info-table mt-2">
        <thead>
          <tr>
            <th>Pontos Fortes</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="height: 60px"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="w-50">
      <table class="visit-info-table flex-fill">
        <tbody>
          <tr *ngFor="let criterion of ['Preço', 'Interesse no imóvel']">
            <td class="bg-table-head fw-bold">{{ criterion }}</td>
            <td *ngFor="let score of [1, 2, 3, 4, 5]" class="text-center">
              {{ score }}
            </td>
          </tr>
        </tbody>
      </table>
      <table class="visit-info-table mt-2">
        <thead>
          <tr>
            <th>Pontos Fracos</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="height: 60px"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <table class="visit-info-table mt-2">
    <thead>
      <tr>
        <th>Observações</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="height: 25px"></td>
      </tr>
      <tr>
        <td style="height: 25px"></td>
      </tr>
    </tbody>
  </table>
  <div class="mt-2">
    <p class="fs-11 mb-1">
      Nesta data, dia {{ getFullVisitDate(visit.date) }}, apresentámos,
      mostrámos, divulgámos e publicitámos o imóvel aqui identificado, ao
      interessado por nós angariado,
      {{ visit.property.listingAgent ?? visit.agentName }}, que tomou
      conhecimento do mesmo, pela primeira vez, através da nossa mediadora
      imobiliária.
    </p>
    <p class="fs-11 mb-1">
      Qualquer relação ou transação relativa a este imóvel, que venha a ser
      realizada com este interessado ou interposta pessoa ou empresa por ele
      indicada, terá de ter a intervenção desta mediadora imobiliária.
    </p>
    <p class="fs-11 mb-1">
      O proprietário e o potencial comprador reconhecem que o incumprimento das
      obrigações ora assumidas implicará o dever de indemnizar a
      {{ entityData?.name }}. pelos prejuízos causados nos termos gerais da
      responsabilidade civil regulada nos artigos 483º e seguintes do Código
      Civil
    </p>
  </div>

  <table class="visit-info-table mt-2" style="width: 100%">
    <tr>
      <td
        class="bg-table-head"
        style="width: 40px; text-align: center; font-weight: bold"
      >
        <div class="vertical-text">Assinaturas</div>
      </td>
      <td style="padding: 0; vertical-align: bottom">
        <table style="width: 100%">
          <tr>
            <td style="width: 30%; text-align: center">O Proprietário</td>
            <td style="width: 70%; height: 30px"></td>
          </tr>
          <tr>
            <td style="width: 30%; text-align: center">O Angariador</td>
            <td style="width: 70%; height: 30px"></td>
          </tr>
          <tr>
            <td style="width: 30%; text-align: center">O Interessado</td>
            <td style="width: 70%; height: 30px">
              <div style="width: 100%; height: 40px"></div>
              <div
                style="
                  border: 1px solid #ccc;
                  padding: 8px 8px;
                  font-size: 12px;
                  display: inline-block;
                "
              ></div>
              <span class="ms-1"
                >Autorizo o tratamento comercial dos meus dados pessoais</span
              >
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>

  <div class="visit-footer mt-2 avoid-page-break">
    <p *ngIf="entityData && !visit.property.storeData" class="text-center">
      {{ entityData?.name }} - AMI: {{ entityData?.license }}
    </p>
    <p
      *ngIf="visit.property.storeData && visit.property.storeData.licenseImo"
      class="text-center"
    >
      {{ visit.property.storeData.name }} - AMI:
      {{ visit.property.storeData.licenseImo }}
    </p>
  </div>
</div>

<div *ngIf="visit && false" id="visit-form">
  <div
    class="visit-form-header d-flex align-items-center justify-content-between"
  >
    <img
      width="30%"
      height="120"
      class="logo-si"
      src="{{ entityData?.image ? logoPath + entityData?.image : '' }}"
      alt="Logo"
    />
    <div class="visit-details">
      <div
        class="w-50 h-100 float-end d-flex flex-column align-items-end justify-content-between"
      >
        <span class="fw-bold">solucoesideais.pt</span>
        <span
          >Lic.
          <span
            *ngIf="
              visit.property.storeData && visit.property.storeData.licenseImo;
              else lineXs
            "
            >{{
              visit.property.storeData
                ? visit.property.storeData.licenseImo
                : ""
            }}</span
          >
          AMI</span
        >
      </div>
    </div>
  </div>
  <div
    class="si-table p-1 w-100 d-flex align-items-center justify-content-between"
  >
    <span class="fs-14 text-white">FICHA DE VISITA</span>
    <span class="fs-14 text-white"
      >Data: {{ visit.date | date: "dd/MM/yyyy" }}</span
    >
  </div>
  <div class="mt-2">
    <p class="line-row">
      <span class="fs-14 fw-bold">Exmo(a). Sr(a) </span>
      <span class="line" *ngIf="visit?.property?.owner; else line">{{
        visit.property.owner
      }}</span>
    </p>
    <p class="line-row">
      <span class="fs-14 fw-bold"
        >Informamos que nesta data e local, sito
      </span>
      <span *ngIf="visit.property?.address; else line">{{
        visit.property.address
      }}</span>
    </p>
    <p class="line-row">
      <span class="fs-14 fw-bold"
        >Mostrámos a propriedade de V. Exª., conforme o contrato de mediação
        imobiliária nº
      </span>
      <span *ngIf="visit.property?.contractNumber; else line">{{
        visit.property.contractNumber
      }}</span>
    </p>
    <p class="line-row">
      <span class="fw-bold">, ao nosso cliente Exmo(a). Sr(a) </span>
      <span *ngIf="visit.clientName; else line">{{ visit.clientName }}</span>
    </p>
  </div>
  <div class="d-flex mt-2">
    <table class="visit-info-table flex-fill me-2">
      <tbody>
        <tr>
          <td>
            <div class="d-flex align-items-center gap-2">
              <div class="property-image">
                <img
                  *ngIf="visit.property.image"
                  width="80"
                  [src]="propertyPath + visit.property.image"
                  alt="Property Image"
                />
              </div>
              <div>
                <div>{{ visit.property.title }}</div>
                <div>
                  {{
                    visit.property.businessType == "SALE"
                      ? "Venda"
                      : "Arrendamento"
                  }}
                  {{ visit.property.price }} {{ visit.property.symbol ?? "€" }}
                </div>
                <div>Área Bruta: {{ visit.property.grossArea }}</div>
                <div>
                  Ano de Construção:
                  {{ visit.property.yearBuilt | date: "dd-MM-yyyy" }}, Classe
                  Energética: {{ visit.property.energeticCertification }}
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="min-width: 220px">
      <table class="visit-info-table mb-2">
        <thead>
          <tr>
            <th>Referência</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ visit.property.reference }}</td>
          </tr>
        </tbody>
      </table>
      <table class="visit-info-table">
        <thead>
          <tr>
            <th>Angariador</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ visit.property.listingAgent ?? visit.agentName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <table class="visit-info-table mt-2">
    <thead>
      <tr>
        <th>Morada</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="height: 25px">{{ visit.property.address }}</td>
      </tr>
    </tbody>
  </table>

  <table class="visit-info-table mt-2">
    <thead>
      <tr>
        <th>
          Avaliação do imóvel pelo interessado (1 é a pior avaliação; 5 é a
          melhor avaliação)
        </th>
      </tr>
    </thead>
  </table>

  <div class="d-flex gap-2 mt-2">
    <div class="w-50">
      <table class="visit-info-table flex-fill">
        <tbody>
          <tr
            *ngFor="let criterion of ['Localização', 'Estado de conservação']"
          >
            <td class="bg-table-head fw-bold">{{ criterion }}</td>
            <td *ngFor="let score of [1, 2, 3, 4, 5]" class="text-center">
              {{ score }}
            </td>
          </tr>
        </tbody>
      </table>
      <table class="visit-info-table mt-2">
        <thead>
          <tr>
            <th>Pontos Fortes</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="height: 60px"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="w-50">
      <table class="visit-info-table flex-fill">
        <tbody>
          <tr *ngFor="let criterion of ['Preço', 'Interesse no imóvel']">
            <td class="bg-table-head fw-bold">{{ criterion }}</td>
            <td *ngFor="let score of [1, 2, 3, 4, 5]" class="text-center">
              {{ score }}
            </td>
          </tr>
        </tbody>
      </table>
      <table class="visit-info-table mt-2">
        <thead>
          <tr>
            <th>Pontos Fracos</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="height: 60px"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <table class="visit-info-table mt-2">
    <thead>
      <tr>
        <th>Observações</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="height: 25px"></td>
      </tr>
      <tr>
        <td style="height: 25px"></td>
      </tr>
    </tbody>
  </table>
  <div class="mt-2">
    <p class="fs-11 mb-1">
      Nesta data, dia {{ getFullVisitDate(visit.date) }}, apresentámos,
      mostrámos, divulgámos e publicitámos o imóvel aqui identificado, ao
      interessado por nós angariado,
      {{ visit.property.listingAgent ?? visit.agentName }}, que tomou
      conhecimento do mesmo, pela primeira vez, através da nossa mediadora
      imobiliária.
    </p>
    <p class="fs-11 mb-1">
      Qualquer relação ou transação relativa a este imóvel, que venha a ser
      realizada com este interessado ou interposta pessoa ou empresa por ele
      indicada, terá de ter a intervenção desta mediadora imobiliária.
    </p>
    <p class="fs-11 mb-1">
      O proprietário e o potencial comprador reconhecem que o incumprimento das
      obrigações ora assumidas implicará o dever de indemnizar a
      {{ entityData?.name }}. pelos prejuízos causados nos termos gerais da
      responsabilidade civil regulada nos artigos 483º e seguintes do Código
      Civil
    </p>
  </div>

  <table class="visit-info-table mt-2" style="width: 100%">
    <tr>
      <td
        class="bg-table-head"
        style="width: 40px; text-align: center; font-weight: bold"
      >
        <div class="vertical-text">Assinaturas</div>
      </td>
      <td style="padding: 0; vertical-align: bottom">
        <table style="width: 100%">
          <tr>
            <td style="width: 30%; text-align: center">O Proprietário</td>
            <td style="width: 70%; height: 30px"></td>
          </tr>
          <tr>
            <td style="width: 30%; text-align: center">O Angariador</td>
            <td style="width: 70%; height: 30px"></td>
          </tr>
          <tr>
            <td style="width: 30%; text-align: center">O Interessado</td>
            <td style="width: 70%; height: 30px">
              <div style="width: 100%; height: 40px"></div>
              <div
                style="
                  border: 1px solid #ccc;
                  padding: 8px 8px;
                  font-size: 12px;
                  display: inline-block;
                "
              ></div>
              <span class="ms-1"
                >Autorizo o tratamento comercial dos meus dados pessoais</span
              >
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>

  <div class="visit-footer mt-2 avoid-page-break">
    <p class="text-center">
      {{ entityData?.name }} - AMI: {{ entityData?.license }}
    </p>
  </div>
</div>

<ng-template #line>
  <div class="line"></div>
</ng-template>
<ng-template #lineXs>
  <div class="line-xs"></div>
</ng-template>
